import moment from 'moment';
import PolicySearchUtil from 'gw-portals-util-angular/PolicySearchUtil';
import simpleTemplate from 'text!./templates/policy-search-result-simple.html';
import detailedTemplate from 'text!./templates/policy-search-result-detailed.html';

/** Search result controller.
 * Scope arguments:
 *  <ul>
 *      <li><strong>policies</strong> - list of policies to display.
 *      <li><strong>selectPolicy</strong> - function with type (Policy) => Unit. Sets a selected policy. May
 *        be called with a null argument to deselect a policy.
 *      <li><strong>selectedPolicy</strong> - current selected policy.
 *  </ul>
 */

const fn = ($compile) => {
    return {
        restrict: 'A',
        scope: {
            policies: '=',
            selectPolicy: '=',
            selectedPolicy: '=',
            iconNameSelector: '=?',
            iconPathSelector: '=?',
            iconAltSelector: '=?',
            insuredSelector: '=?',
            addressSelector: '=?',
            effectiveDateSelector: '=?',
            expirationDateSelector: '=?'
        },

        link: (scope, element, attrs) => {
            scope.$watch('policies', () => {
                scope.inForcePolicies = scope.policies.filter((tmpPolicy) => {
                    return !tmpPolicy.isCancelled && !(moment().isBefore(moment(tmpPolicy.effective)));
                });
            });

            let templateStr = simpleTemplate;
            if ('showInsuredDetails' in attrs) {
                templateStr = detailedTemplate;
            }

            element.html(templateStr).show();
            $compile(element.contents())(scope);
        },

        controller: ['$scope', 'InsuranceSuiteMetadata', (scope, InsuranceSuiteMetadata) => {
            const policyTypeTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('PolicyType');
            const policySubTypeTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('PolicySubType_PSA'); // PSA
            const makeTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('VehicleManufacturer'); // PSA
            const countryTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('Country'); // PSA
            scope.PolicySearchUtil = PolicySearchUtil;
            scope.isSelected = (item) => {
                return scope.selectedPolicy && scope.selectedPolicy.policyNumber === item.policyNumber;
            };
            scope.policyTypeName = (policyTypeCode) => {
                return policyTypeTypelist.getCode(policyTypeCode).name;
            };
            scope.policySubTypeNamePSA = (policySubTypeCode) => {
                return policySubTypeTypelistPSA.getCode(policySubTypeCode).name;
            };
            scope.countryPSA = (countryCode) => {
                return countryCode ? countryTypelistPSA.getCode(countryCode).name : '-';
            };
            scope.makePSA = (makeCode) => {
                return makeCode ? makeTypelistPSA.getCode(makeCode).name : '-';
            };
            scope._selectPolicy = (item) => {
                scope.selectPolicy(item);
            };
            //UCWAR-544 display effective status on policy search results
            scope.checkEffectiveStatus = (item) => {
                var isGreenOrRed = false
                var itemWarranty = item.coverages != undefined?item.coverages.filter(function (coverage) {
                    return (coverage.name === 'Warranty' || coverage.name === 'Garantía' || coverage.name === 'Garantie');
                })[0]:undefined;
                if(item.policySubType_PSA == 'egvo'){
                    if (itemWarranty) {
                        if (item.currentDate >= itemWarranty.effectiveDate && item.currentDate <= itemWarranty.expirationDate) {
                            isGreenOrRed = true
                        }
                        else {
                            isGreenOrRed = false
                        }
                    }
                }
                else if(item.policySubType_PSA == 'gvo'){
                    if (item) {
                        if (item.currentDate >= item.effectiveDate && item.currentDate <= item.expirationDate) {
                            isGreenOrRed = true
                        }
                        else {
                            isGreenOrRed = false
                        }
                    }
                }
                return isGreenOrRed;
            }
            scope.checkWarrantyCoverage = (item) => {
                var isWarranty = item.coverages != undefined?item.coverages.filter(function (coverage) {
                    return (coverage.name === 'Warranty' || coverage.name === 'Garantía' || coverage.name === 'Garantie');
                })[0]:undefined;
                var warrantyActive = false
                if (isWarranty != undefined) {
                    warrantyActive = true
                } else {
                    warrantyActive = false
                }
                return warrantyActive
            }

            scope.checkCarMaintenanceCoverage = (item) => {
                var isCarMaintenance = item.coverages != undefined?item.coverages.filter(function (coverage) {
                    return (coverage.name === 'Maintenance' || coverage.name === 'Entretien' || coverage.name === 'Mantenimiento');
                })[0]:undefined;
                var carMaintActive = false
                if (item.policySubType_PSA == 'egvo') {
                    if (isCarMaintenance != undefined) {
                        carMaintActive = true
                    } else {
                        carMaintActive = false
                    }
                    return carMaintActive
                }
            }
            scope.checkEGVOCarMaintenanceCoverage = (item) => {
                var isActive = false
                if (item.policySubType_PSA == 'egvo') {
                    if (item) {
                        if (item.currentDate >= item.effectiveDate && item.currentDate <= item.expirationDate) {
                            isActive = true
                        }
                        else {
                            isActive = false
                        }
                    }
                }
                return isActive;
            }
        }]
    };
};
fn.$inject = ['$compile'];

export default fn;